import { render, staticRenderFns } from "./RecycleBin.vue?vue&type=template&id=3e95d7dd&scoped=true&"
import script from "./RecycleBin.vue?vue&type=script&lang=js&"
export * from "./RecycleBin.vue?vue&type=script&lang=js&"
import style0 from "./RecycleBin.vue?vue&type=style&index=0&id=3e95d7dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e95d7dd",
  null
  
)

export default component.exports